import { plaintextValidator } from '../fields';
import ruleBuilder from '../utils/RuleBuilder';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  ...ruleBuilder('viewCondition.operands')
};
